import React from 'react';
import { formatPrice } from '../data/price';
import { CREAM } from '../theme';

export default function PriceTag({ price, style }) {
  return (
    <span style={{ fontSize: 18, color: CREAM, whiteSpace: 'nowrap', ...style }}>{formatPrice(price)}</span>
  );
}
